import React, { Component } from 'react';

export class CDBMain extends Component {

    static displayName = CDBMain.name;

    public static menuHeaderClass = 'cdb-admin-main__menu-header';
    public static contentHeaderClass = 'cdb-admin-main__content-header'; 
    
    render() {
        return (
            <div className="cdb-admin-main">
                <div className={CDBMain.menuHeaderClass}/>
                <div className={CDBMain.contentHeaderClass}/>
                {this.props.children}
            </div>
        );
    }
}